<template>
  <div style="text-align: center; width: 100%; margin-top: 30px;">
    <a-spin size="large" />
  </div>
</template>
<script>
import RouteQueryMixins from '@/mixins/RouteQueryMixins'
import { mapActions } from 'vuex'

export default {
  mixins: [RouteQueryMixins],
  created() {
    this.dispatch()
  },
  methods: {
    ...mapActions(['login', 'logout']),
    dispatch() {
      const loginData = {
        appId: this.mixinAppId,
        appToken: this.mixinToken
      }
      this.logout().finally(() => {
        this.login(loginData).then(res => {
          if (res.code === 0) {
            setTimeout(() => {
              this.$router.replace({ path: '/app/review/page', query: { ...this.$route.query } })
            }, 100);
          } else {
            this.$message.error(res.message || this.$t('登录失败'))
          }
        })
      })
    }
  }
}
</script>